import { createAction, props } from '@ngrx/store';

export const PoiStripeResultIntlComponentActions = {
  initialized: createAction(
    '[POI Intl Stripe Result] Initialized',
    props<{ status?: string; stripeSessionId?: string }>(),
  ),
};
